import React from "react";
import BarChart from "components/BarChart";
import ResultsNoDataBox from "./styles/ResultsNoDataBox";
import ResultsNoDataText from "./styles/ResultsNoDataText";
import ResultsWrapper from "./styles/ResultsWrapper";
import ResultsVerticalWrapper from "./styles/ResultsVerticalWrapper";
import ResultsHorizontalWrapper from "./styles/ResultsHorizontalWrapper";
import ResultsAverageHeader from "./styles/ResultsAverageHeader";
import ResultsAveragePrice from "./styles/ResultsAveragePrice";
import ResultsPercentileBar from "./styles/ResultsPercentileBar";
import ResultsHorizontalLine from "./styles/ResultsHorizontalLine";
import ResultsPercentileWrapper from "./styles/ResultsPercentileWrapper";
import ResultsResponsesNumber from "./styles/ResultsResponsesNumber";
import Button from "components/Button";

import {
  getPercentile
} from "helpers";

import {
  getAverage
} from "helpers";

class NewResults extends React.PureComponent {
  constructor() {
    super();

    this.state = {
      filters: {},
      chartData: {},
      showInfo: false,
    }

  }

  render() {
    let { resultsData, isAuthenticated, filtersArray, isResultsDisplayed } = this.props;
    
    const { showInfo } = this.state;

    let { chartData, labels, userResponseIndex, filteredResponses, formData, typeOfResult } =
      resultsData;

    return (
      <ResultsWrapper className={`graph-container ${isResultsDisplayed ? "result-opened" : ""} ${isAuthenticated ? "authenticated" : "unauthenticated"}`}>
        {typeOfResult == "individual" && filtersArray.length > 0 ? (
          <ResultsVerticalWrapper
            thisStylesSmall={filteredResponses.length != 0 && filtersArray.length ? { marginBottom: "65px" } : {}}
          >
            <ResultsHorizontalWrapper>
              <ResultsAverageHeader>
                {filteredResponses.length ? "Average salary (USD) is:" : ""}
              </ResultsAverageHeader>
            </ResultsHorizontalWrapper>
            <ResultsHorizontalWrapper>
              <ResultsAveragePrice>
                {filteredResponses.length ? (
                  <>
                    {`$${
                      Math.round(
                        (getAverage(filteredResponses) / 1000) * 10
                      ) / 10
                    }K`}
                    <span>{"per year"}</span>
                  </>
                ) : (
                  ""
                )}
              </ResultsAveragePrice>
            </ResultsHorizontalWrapper>
          </ResultsVerticalWrapper>
        ) : ("")}
      {typeOfResult == "global" ? (
        <>
          <ResultsNoDataBox>
            <ResultsNoDataText>
              <p className="error-title">There are no available results for this at the moment.</p>
              <p className="error-description">We're constantly enhancing our salary calculator. Want to contribute to its development? Sign up using the form below, and we'll reach out to you promptly to get started!</p>
              <a href="https://www.productmarketingalliance.com/product-marketing-salary-and-landscape-survey/">
                <Button
                  title={"Contribute to salary survey"}
                  className={"btn-primary-outline"}
                />
              </a>
            </ResultsNoDataText>
          </ResultsNoDataBox>
          <h2 thisStyles={{
              marginTop: "24px",
            }}>Global result</h2>
          <ResultsVerticalWrapper
            thisStylesSmall={filteredResponses.length != 0 && filtersArray.length ? { marginBottom: "65px", marginTop: "24px"} : {}}
          >
            <ResultsHorizontalWrapper>
              <ResultsAverageHeader>
                Average salary (USD) is:
              </ResultsAverageHeader>
            </ResultsHorizontalWrapper>
            <ResultsHorizontalWrapper>
              <ResultsAveragePrice>
                <>
                  {`$${
                    Math.round(
                      (getAverage(filteredResponses) / 1000) * 10
                    ) / 10
                  }K`}
                  <span>{"per year"}</span>
                </>
              </ResultsAveragePrice>
            </ResultsHorizontalWrapper>
          </ResultsVerticalWrapper>
          <BarChart
            chartData={chartData}
            labels={labels}
            userResponseIndex={userResponseIndex}
            formData={formData}
          />
          <ResultsHorizontalWrapper
            thisStyles={{
              width: "100%",
              justifyContent: "space-between",
              marginTop: "16px",
              marginBottom: "40px",
            }}
          >
            { filteredResponses.length ? (<ResultsResponsesNumber responses={filteredResponses.length}>
            {"Number of responses:"}
            <span>{filteredResponses.length}</span>
          </ResultsResponsesNumber>) : ("")  }
          { filteredResponses.length ? (
            <>
            {chartData[userResponseIndex] ? (
              <span> Your current annual salary (USD)</span>
            ) : (
              ""
            )}
            </>
          ) : ("")}
          </ResultsHorizontalWrapper>
          <ResultsVerticalWrapper
            thisStyles={{
              width: "100%",
              position: "absolute",
            }}
          >
            {/* {filtersArray.length ? (
              
            ) : ("")} */}
            <ResultsHorizontalWrapper
              thisStyles={{
                justifyContent: "flex-start",
                width: "90%",
                minWidth: "30rem",
                maxWidth: "80rem",
              }}
            >
              {/* <ResultsInfoIcon
              onMouseOver={() => {
                this.setState({
                  showInfo: true,
                });
              }}
              onMouseOut={() => {
                this.setState({
                  showInfo: false,
                });
              }}
            >
              {"?"}
            </ResultsInfoIcon>
            {showInfo ? (
              <ResultsInfoText>{percentileExplanation}</ResultsInfoText>
            ) : (
              ""
            )} */}
            </ResultsHorizontalWrapper>
            <h5 className="percentile-title">Percentile</h5>
            <ResultsPercentileWrapper>
              <ResultsPercentileBar index={1}>
                {"25"}
                {!showInfo ? <sup>th</sup> : ""}

                {"percentile:"}
              </ResultsPercentileBar>
              <span>
                $
                {Math.round(
                  (getPercentile(25, filteredResponses) / 1000) * 10
                ) / 10}
                K
              </span>
            </ResultsPercentileWrapper>

            <ResultsPercentileWrapper>
              <ResultsPercentileBar index={2}>
                {"50"}
                {!showInfo ? <sup>th</sup> : ""}
                {"percentile / Median:"}
              </ResultsPercentileBar>
              <span>
                $
                {Math.round(
                  (getPercentile(50, filteredResponses) / 1000) * 10
                ) / 10}
                K
              </span>
            </ResultsPercentileWrapper>
            <ResultsPercentileWrapper>
              <ResultsPercentileBar index={3}>
                {"75"}
                {!showInfo ? <sup>th</sup> : ""}
                {"percentile:"}
              </ResultsPercentileBar>
              <span>
                $
                {Math.round(
                  (getPercentile(75, filteredResponses) / 1000) * 10
                ) / 10}
                K
              </span>
            </ResultsPercentileWrapper>

            <p
              style={{
                marginTop: "16px",
                fontSize: "14px",
                // fontWeight: "300",
                lineHeight: "22px",
                color: "#6C6C6C",
              }}
            >
              The percentiles here indicate the annual salary below which a
              given percentage (25%, 50% or 75%) of observations in the
              observation group falls; i.e., 75th percentile = $100K means
              that 75% of people earn $100K or less annually (only 25% of
              people earn more). The 50th percentile is the central value,
              also known as the median.
            </p>

            <ResultsHorizontalLine />
          </ResultsVerticalWrapper>
        </>
      ) : (
        <>
        
        </>
      )}
      {typeOfResult == "individual" && filtersArray.length == 0 ? ( 
        <ResultsNoDataBox>
          <ResultsNoDataText>
            <p className="error-title">Please select a filter to see the results.</p>
            <p className="error-description">To see your salary calculation, simple choose a filter. This helps tailor the results to your specific requirements.</p>
          </ResultsNoDataText>
        </ResultsNoDataBox>
      ) : (
        ""
      )}
      {typeOfResult == "individual" && filtersArray.length > 0 ? ( 
        <BarChart
          chartData={chartData}
          labels={labels}
          userResponseIndex={userResponseIndex}
          formData={formData}
        />
      ) : (
        ""
      )}
      
      {typeOfResult == "individual" && filtersArray.length > 0 ? (
        <ResultsHorizontalWrapper
          thisStyles={{
            width: "100%",
            justifyContent: "space-between",
            marginTop: "16px",
            marginBottom: "40px",
          }}
        >
          { filteredResponses.length ? (<ResultsResponsesNumber responses={filteredResponses.length}>
          {"Number of responses:"}
          <span>{filteredResponses.length}</span>
        </ResultsResponsesNumber>) : ("")  }
        { filteredResponses.length ? (
          <>
          {chartData[userResponseIndex] ? (
            <span> Your current annual salary (USD)</span>
          ) : (
            ""
          )}
          </>
        ) : ("")}
          
        </ResultsHorizontalWrapper>
      ) : ("")}
      {/* <ResultsHorizontalLine /> */}
      {filteredResponses.length > 2 && filtersArray.length > 0 ? (
        
        <>
        {typeOfResult == "individual" ? (
          <ResultsVerticalWrapper
            thisStyles={{
              width: "100%",
              position: "absolute",
            }}
          >
            {/* {filtersArray.length ? (
              
            ) : ("")} */}
            <ResultsHorizontalWrapper
              thisStyles={{
                justifyContent: "flex-start",
                width: "90%",
                minWidth: "30rem",
                maxWidth: "80rem",
              }}
            >
              {/* <ResultsInfoIcon
              onMouseOver={() => {
                this.setState({
                  showInfo: true,
                });
              }}
              onMouseOut={() => {
                this.setState({
                  showInfo: false,
                });
              }}
            >
              {"?"}
            </ResultsInfoIcon>
            {showInfo ? (
              <ResultsInfoText>{percentileExplanation}</ResultsInfoText>
            ) : (
              ""
            )} */}
            </ResultsHorizontalWrapper>
            <h5 className="percentile-title">Percentile</h5>
            <ResultsPercentileWrapper>
              <ResultsPercentileBar index={1}>
                {"25"}
                {!showInfo ? <sup>th</sup> : ""}

                {"percentile:"}
              </ResultsPercentileBar>
              <span>
                $
                {Math.round(
                  (getPercentile(25, filteredResponses) / 1000) * 10
                ) / 10}
                K
              </span>
            </ResultsPercentileWrapper>

            <ResultsPercentileWrapper>
              <ResultsPercentileBar index={2}>
                {"50"}
                {!showInfo ? <sup>th</sup> : ""}
                {"percentile / Median:"}
              </ResultsPercentileBar>
              <span>
                $
                {Math.round(
                  (getPercentile(50, filteredResponses) / 1000) * 10
                ) / 10}
                K
              </span>
            </ResultsPercentileWrapper>
            <ResultsPercentileWrapper>
              <ResultsPercentileBar index={3}>
                {"75"}
                {!showInfo ? <sup>th</sup> : ""}
                {"percentile:"}
              </ResultsPercentileBar>
              <span>
                $
                {Math.round(
                  (getPercentile(75, filteredResponses) / 1000) * 10
                ) / 10}
                K
              </span>
            </ResultsPercentileWrapper>

            <p
              style={{
                marginTop: "16px",
                fontSize: "14px",
                // fontWeight: "300",
                lineHeight: "22px",
                color: "#6C6C6C",
              }}
            >
              The percentiles here indicate the annual salary below which a
              given percentage (25%, 50% or 75%) of observations in the
              observation group falls; i.e., 75th percentile = $100K means
              that 75% of people earn $100K or less annually (only 25% of
              people earn more). The 50th percentile is the central value,
              also known as the median.
            </p>

            <ResultsHorizontalLine />
          </ResultsVerticalWrapper>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}
      </ResultsWrapper>
    );
  }
}

export default NewResults;